import PropTypes from 'prop-types';
import { StoreProvider } from './StoreProvider';
import { ThemeProvider } from './ThemeProvider';
import { CssBaseline } from '@mui/material';

export const AppProviders = ({ children }) => {
  return (
    <StoreProvider>
      <ThemeProvider>{children}</ThemeProvider>
      <CssBaseline />
    </StoreProvider>
  );
};

AppProviders.propTypes = {
  children: PropTypes.any,
};
